import React from "react";
import { useLocation } from "react-router-dom";
import { getBasePath } from "../lib/buildSnapshot";
import { useI18n } from "./context";
import { languagePath } from "./routes";
export default function LanguageSwitcher() {
    const { pathname, search, hash } = useLocation();
    const { language } = useI18n();
    const target = (lang) => getBasePath() + languagePath(pathname, lang) + search + hash;
    const other = language === "hi" ? "en" : "hi";
    return <nav aria-label="Choose language / भाषा चुनें" data-testid="language-switcher" className="shrink-0">
        <div className="hidden items-center rounded-full border border-brand-navy/15 bg-white p-1 text-xs font-bold sm:flex">
            <a href={target("en")} lang="en" hrefLang="en" aria-current={language === "en" ? "true" : undefined} className={"rounded-full px-2 py-1.5 " + (language === "en" ? "bg-brand-navy text-white" : "text-brand-navy")}>English</a>
            <a href={target("hi")} lang="hi" hrefLang="hi" aria-current={language === "hi" ? "true" : undefined} className={"rounded-full px-2 py-1.5 " + (language === "hi" ? "bg-brand-navy text-white" : "text-brand-navy")}>हिन्दी</a>
        </div>
        <a className="inline-flex rounded-full border border-brand-navy/15 bg-white px-2.5 py-2 text-xs font-bold text-brand-navy sm:hidden" href={target(other)} lang={other} hrefLang={other}>{other === "hi" ? "हिन्दी" : "English"}</a>
    </nav>;
}
